<template>
  <div class="row top-form">
    <div class=" col-lg-6 col-md-6 col-sm-3">
      <field-wrapper label="Get all pages" type="checkbox" v-model="values.getAllPages" tooltip="Leave this checked to process all search result pages." id="get_all_pages"/>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-9">
      <field-wrapper label="Per page limit (select the highest your subscription allows)" type="select" v-model="values.limit" :options="options.limits" tooltip="Search result page size. Depends on your subscription." id="pagesize_limit"
                     :close-on-select="true"/>
    </div>
  </div>
</template>
<script>
  import Multiselect from 'vue-multiselect'
  import { FILTER_OPTIONS } from '@/app/wdc/form/fixtures'
  import fieldWrapper from '@/components/shared/field-wrapper'

  export default {
    components: {
      Multiselect,
      fieldWrapper
    },
    props: {
      values: Object
    },
    name: 'topForm',
    data () {
      return {
        options: FILTER_OPTIONS
      }
    }
  }
</script>
<style>
</style>
